import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DialogContent, DialogFooter, DialogHeader, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { CancelButton, FormDialog, SubmitButton, TextAreaField } from 'shared/domains/forms';
export function ContextDialog(props) {
    const { onClose, onSubmit } = props;
    const handleSubmit = (values) => {
        onSubmit(values.context);
    };
    return (<FormDialog onClose={onClose} onSubmit={handleSubmit} initialValues={{ context: '' }}>
      <DialogHeader icon={<Falcon icon="arrow-rotate-forward"/>} title={t({
            comment: 'Document approval check - Rerun check with more context dialog - title',
            message: 'Rerun with more context',
        })}/>
      <DialogContent>
        <Typography $fontSize="small" $appearance="200">
          <Trans comment="Document approval check - Rerun check with more context dialog - description">
            Please provide additional context to help improve the accuracy of the approval check.
          </Trans>
        </Typography>
        <TextAreaField name="context" autosizeHeight maxHeight={160} placeholder={t({
            comment: 'Document approval check - Rerun check with more context dialog - textarea placeholder',
            message: 'Additional context...',
        })}/>
      </DialogContent>
      <DialogFooter>
        <CancelButton size="small" appearance="secondary" onClick={onClose}>
          <Trans comment="Document approval check - Rerun check with more context dialog - cancel button label">
            Cancel
          </Trans>
        </CancelButton>
        <SubmitButton size="small">
          <Trans comment="Document approval check - Rerun check with more context dialog - rerun check button label">
            Rerun check
          </Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
